interface AgePickerProps {
  minAge: number;
  maxAge: number;
  value: number;
  onValueChange: (age: number) => void;
}

export function AgePicker({ minAge, maxAge, value, onValueChange }: AgePickerProps) {
  const ages = Array.from({ length: maxAge - minAge + 1 }, (_, i) => minAge + i);

  return (
    <div className="mb-5">
      <select
        value={value}
        onChange={(e) => onValueChange(Number(e.target.value))}
        className="w-full min-h-[48px] rounded-xl border-2 border-slate-200 bg-card-bg px-4 py-3 text-base text-text-heading outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none"
        aria-label="Yaş seçin"
      >
        {ages.map((age) => (
          <option key={age} value={age}>
            {age}
          </option>
        ))}
      </select>
    </div>
  );
}
